import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { TIMELINE_RULER_HEIGHT } from '../../consts'
import LoadingSkeleton from 'common-components/LoadingSkeleton'
import { SpinningLoader } from 'common-components'

export const Thumbnail = styled.div<{
  $bgImageUrl: string
  $blurred?: boolean
  $isThumbLoading?: boolean
}>`
  background: ${({ $bgImageUrl }) => `url(${$bgImageUrl})`};
  background-size: contain;
  opacity: ${({ $isThumbLoading }) => ($isThumbLoading ? 0 : 1)};
  transition: opacity 0.3s ease-in;
  min-width: 150px;
  height: 100%;
  border-radius: 4px;
  width: 100%;
  ${({ $blurred }) =>
    $blurred &&
    css`
      filter: blur(2px);
    `}
`

export const VideoThumbnail = styled.div<{
  $width: number
  $left: number
}>`
  position: absolute;
  left: ${({ $left }) => `${$left}px`};
  top: 0;
  display: flex;
  height: 100%;
  width: ${({ $width }) => `${$width}px`};
  border-radius: 4px;
  overflow: hidden;
`

export const VideoFrame = styled.img`
  height: 100%;
  object-fit: cover;
`

export const VideoFrameSkeleton = styled(LoadingSkeleton)<{ $width: number }>`
  flex-shrink: 0;
  height: 100%;
`

export const ThumbnailSkeletonBg = styled(LoadingSkeleton)`
  background-image: linear-gradient(
    90deg,
    ${COLORS.secondaryUltraLight} 0%,
    ${COLORS.white} 50%,
    ${COLORS.secondaryUltraLight} 100%
  );
  position: absolute;
`

export const TextThumbnailText = styled.span`
  display: block;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const TextThumbnail = styled.div<{ $fillColor?: string }>`
  background-color: #f5a623;
  color: ${COLORS.white};
  width: 100%;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 4px;
  font-weight: 600;
  font-size: 10px;
  padding: 0 12px 0 16px;
`

export const TrackItem = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 4px;
  opacity: 1;
  /* scrollIntoView: keep item below sticky timescale (see MainContainer/StickyContainer) */
  scroll-margin-top: ${TIMELINE_RULER_HEIGHT}px;
`
export const Duration = styled.p`
  position: absolute;
  width: 35px;
  border-radius: 2px;
  opacity: 0.7;
  font-weight: 600;
  font-size: 10px;
  text-align: center;
  background-color: ${COLORS.secondaryExtraDark};
  bottom: 4px;
  left: 4px;
  color: ${COLORS.white};
  padding: 2px 4px;
`

export const VisualMediaTracks = styled.div`
  & .visual-media-track {
    background-color: ${COLORS.primaryLight};
    border-radius: 4px;
  }
`

export const BlobLoader = styled(SpinningLoader)`
  z-index: 2;
  position: absolute;
  bottom: 2px;
  right: 8px;
`
export const TracksContainer = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: 1fr auto;
  align-items: center;
`
